import { default as DefinitionPaneDefault } from '../../DefinitionPane/DefinitionPaneDefault';
import { default as ValuePane } from './DeVerbValuePane';

export default { ValuePane, DefinitionPane: DefinitionPaneDefault };
